<ui-section title="Registration Details">
	<div section-content class="flex flex-col mb-3 gap-6">
		<div class="flex items-stretch gap-3">
			<app-date-picker
				label="Registration Date"
				[ngModel]="mortgage?.registrationDate"
				(ngModelChange)="updateRegistrationDate($event)"
			></app-date-picker>
			<app-input
				label="Registration Number"
				[ngModel]="mortgage?.registrationNumber"
				(debounce)="updateRegistrationNumber($event)"
			></app-input>
		</div>
		<div class="flex flex-col">
			<app-checkbox
				type="clear"
				[ngModel]="mortgage?.assignmentOfRents"
				(ngModelChange)="setAssignmentOfRents($event)"
				>Assignment of Rents</app-checkbox
			>
			<div class="flex gap-3 w-full mt-3" *ngIf="mortgage?.assignmentOfRents">
				<app-date-picker
					label="Registration Date"
					[ngModel]="mortgage?.assignmentOfRentsRegDate"
					(ngModelChange)="updateAssignmentOfRentsRegDate($event)"
				></app-date-picker>
				<app-input
					label="Registration Number"
					[ngModel]="mortgage?.assignmentOfRentsRegNumber"
					(debounce)="updateAssignmentOfRentsRegNumber($event)"
				></app-input>
				<app-input
					label="PPSA Registration Number"
					[ngModel]="mortgage?.assignmentOfRentsPpsaRegNumber"
					(debounce)="updateAssignmentOfRentsPpsaRegNumber($event)"
				>
				</app-input>
			</div>
		</div>
		<div class="flex flex-col">
			<app-checkbox
				type="clear"
				[ngModel]="mortgage?.generalSecurityAgreement"
				(ngModelChange)="setGeneralSecurityAgreement($event)"
				>General Security Agreement</app-checkbox
			>
			<div
				class="flex gap-3 w-2/3 mt-3"
				*ngIf="mortgage?.generalSecurityAgreement"
			>
				<app-date-picker
					label="Registration Date"
					[ngModel]="mortgage?.generalSecurityAgreementRegDate"
					(ngModelChange)="updateGeneralSecurityAgreementRegDate($event)"
				></app-date-picker>
				<app-input
					label="GSA Registration Number"
					[ngModel]="mortgage?.generalSecurityAgreementRegNumber"
					(debounce)="updateGeneralSecurityAgreementRegNumber($event)"
				></app-input>
			</div>
		</div>
	</div>
</ui-section>

<ui-section title="Fees & Charges">
	<div section-content class="flex flex-col mb-3 gap-6">
		<app-checkbox
			type="clear"
			[ngModel]="mortgage?.hideRegistrationFee"
			(ngModelChange)="setHideRegistrationFee($event)"
		>
			Hide Registration Of Mortgage
		</app-checkbox>
	</div>
</ui-section>

<ui-section title="Mortgage Payment Method">
	<div section-content class="flex flex-col gap-y-4">
		<app-radio-group
			label="Select A Payment Method"
			[items]="paymentMethodOptions"
			type="compact"
			[ngModel]="mortgage?.paymentMethod"
			(ngModelChange)="updatePaymentMethod($event)"
		></app-radio-group>

		<ng-container [ngSwitch]="mortgage?.paymentMethod">
			<ng-container *ngSwitchCase="mortgagePaymentMethods.PRE_AUTHORIZED_DEBIT">
				<app-input
					label="Payee Name"
					[ngModel]="mortgage?.paymentMethodPayeeName"
					(debounce)="updatePaymentMethodPayeeName($event)"
				></app-input>

				<div>
					<app-lender-search-input-v2
						[selectedInstitution]="mortgage?.paymentMethodFinancialInstitution"
						(onSelected)="onChangeFinancialInstitution($event)"
					></app-lender-search-input-v2>
				</div>

				<div
					[ngClass]="{
						'cursor-not-allowed opacity-40 pointer-events-none':
							!mortgage?.paymentMethodFinancialInstitution,
					}"
				>
					<label>Branch</label>
					<app-financial-institution-branch-search
						*ngIf="
							!mortgage?.paymentMethodFinancialInstitution?.branch;
							else selectedBranch
						"
						[financialInstitution]="mortgage?.paymentMethodFinancialInstitution"
						[mortgageeType]="mortgageeType.INSTITUTION"
						[autoComplete]="true"
						(onSelectedBranch)="onChangeBranch($event)"
						[required]="true"
					>
					</app-financial-institution-branch-search>
				</div>

				<ng-template #selectedBranch>
					<div
						class="flex gap-2 justify-between items-center py-1 px-3 pr-1 border rounded-md"
						*ngIf="selectedBranch"
					>
						<div class="flex gap-2">
							<span class="whitespace-nowrap p-sm"
								>{{
									mortgage?.paymentMethodFinancialInstitution?.branch
										?.transitNumber
								}}
								|
							</span>
							<ui-address
								class="[&>*>*]:text-sm [&>*>*]:text-gray-600"
								type="inline"
								[address]="mortgage?.paymentMethodFinancialInstitution?.address"
							/>
						</div>
						<ui-button
							icon="x"
							preset="ICON_DEFAULT"
							size="sm"
							(click)="onChangeBranch()"
						/>
					</div>
				</ng-template>

				<app-input
					label="Account Number"
					[ngModel]="mortgage?.paymentMethodAccountNumber"
					(debounce)="updatePaymentMethodAccountNumber($event)"
				></app-input>
			</ng-container>

			<ng-container *ngSwitchCase="mortgagePaymentMethods.POST_DATED_CHEQUE">
				<app-input
					type="number"
					label="Number of Cheques"
					[ngModel]="mortgage?.paymentMethodNumberOfCheques"
					(debounce)="updatePaymentMethodNumberOfCheques($event)"
				></app-input>
			</ng-container>

			<ng-container *ngSwitchCase="mortgagePaymentMethods.OTHER">
				<app-input
					label="Payment Method"
					[ngModel]="mortgage?.paymentMethodOther"
					(debounce)="updatePaymentMethodOther($event)"
				></app-input>
			</ng-container>
		</ng-container>

		<!-- <atomic-button-group label="Select A Payment Method" type="pill" [options]="paymentMethodOptions"></atomic-button-group> -->
	</div>
</ui-section>
